<div class="email-signature-page">
    <div class="title">
        <p class="vox-heading-2" translate>internal-facilities.email-signature.title</p>
    </div>
    <hr />
    <form [formGroup]="dataForm" (ngSubmit)="generateSign()" class="form-container">
        <div class="row">
            <div class="col-12">
                <label for="image-url" translate>internal-facilities.email-signature.form.image-url.label</label>
                <div class="vox-input-group vox-input-group_dense"
                    [ngClass]="{'vox-input-group_invalid': isInvalid('imageUrl')}">
                    <input class="vox-text-field" type="url" id="image-url"
                        placeholder="{{ 'internal-facilities.email-signature.form.image-url.placeholder' | translate }}"
                        formControlName="imageUrl" /><i
                        class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
                        class="vox-input-group__error-message"
                        translate>internal-facilities.email-signature.form.error</span>
                </div>
            </div>
            <div class="col-12">
                <label for="first-name" translate>internal-facilities.email-signature.form.first-name.label</label>
                <div class="vox-input-group vox-input-group_dense"
                    [ngClass]="{'vox-input-group_invalid': isInvalid('name')}">
                    <input class="vox-text-field" type="text" id="first-name"
                        placeholder="{{ 'internal-facilities.email-signature.form.first-name.placeholder' | translate }}"
                        formControlName="name" /><i
                        class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
                        class="vox-input-group__error-message"
                        translate>internal-facilities.email-signature.form.error</span>
                </div>
            </div>
            <div class="col-12">
                <label for="role" translate>internal-facilities.email-signature.form.role.label</label>
                <div class="vox-input-group vox-input-group_dense"
                    [ngClass]="{'vox-input-group_invalid': isInvalid('role')}">
                    <input class="vox-text-field" type="text" id="role"
                        placeholder="{{ 'internal-facilities.email-signature.form.role.placeholder' | translate }}"
                        formControlName="role" /><i
                        class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
                        class="vox-input-group__error-message"
                        translate>internal-facilities.email-signature.form.error</span>
                </div>
            </div>
            <div class="col-12">
                <label for="email" translate>internal-facilities.email-signature.form.country.label</label>
                <div ngbDropdown class="vox-dropdown-input">
                    <button
                      role="button"
                      type="button"
                      data-toggle="dropdown"
                      ngbDropdownToggle>
                      {{'internal-facilities.email-signature.form.country.' + selectedCountry | translate}}
                    </button>
                    <div ngbDropdownMenu>
                      <a
                        type="button"
                        (click)="onChangeCountry(country)"
                        *ngFor="let country of countries"
                        ngbDropdownItem>
                        {{'internal-facilities.email-signature.form.country.' + country | translate}}
                      </a>
                    </div>
                  </div>
            </div>
            <div class="col-12">
                <label translate>internal-facilities.email-signature.form.team.label</label>
                <div ngbDropdown class="vox-dropdown-input" placement="bottom">
                    <button type="button" id="team-dropdown"
                        ngbDropdownToggle
                        [disabled]="teams.length === 1">
                        {{'internal-facilities.email-signature.form.team.teams.' + selectedTeam | translate}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="team-dropdown">
                        <button ngbDropdownItem (click)="onChangeTeam(team)"
                            type="button" *ngFor="let team of teams">
                            {{'internal-facilities.email-signature.form.team.teams.' + team |
                            translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="submit-container">
            <button class="vox-btn vox-btn-primary" type="submit" [disabled]="dataForm.invalid" translate>
                internal-facilities.email-signature.form.button
            </button>
        </div>
    </form>
    <div class="preview-container">
        <div class="row">
            <div class="preview-container__top col-12">
                <h3 translate>internal-facilities.email-signature.preview.title</h3>
            </div>
            <div class="preview-container__bottom col-12">
                <div class="preview-container__table" [innerHtml]="safeSignature">
                </div>
                <button class="vox-btn vox-btn-secondary" (click)="copyImage()"
                    translate>internal-facilities.email-signature.preview.button</button>
            </div>
        </div>
    </div>
    <div class="code-container">
        <div class="row">
            <div class="code-container__top col-12">
                <h3 translate>internal-facilities.email-signature.code.title</h3>
            </div>
            <div class="code-container__bottom col-12">
                <textarea readonly rows="10" [value]="signature || ''" #htmlSign></textarea>
                <button class="vox-btn vox-btn-secondary" (click)="copyHTML()"
                    translate>internal-facilities.email-signature.code.button</button>
            </div>
        </div>
    </div>
</div>
